import { cn } from '@/lib/utils';

const H2 = ({
    variant = 'default',
    color = 'black',
    className,
    ...props
}: React.HTMLAttributes<HTMLHeadingElement> & {
    variant?: 'default' | 'italic' | 'small';
    color?: 'black' | 'inherit';
}) => {
    const variantClasses = {
        default:
            'lg:text-[32px] text-[28px] 2xl:text-[40px] abc inline-block leading-[120%]',
        italic: 'lg:text-[32px] text-[28px] 2xl:text-[40px] abc inline-block leading-[120%] italic abc-italic',
        small: 'lg:text-[32px] max-[365px]:text-[20px] text-[24px] 2xl:text-[40px] abc inline-block leading-[120%]',
    };

    const colorClasses = {
        black: 'text-black',
        inherit: 'text-inherit',
    };

    return (
        <h2
            className={cn(
                variantClasses[variant],
                colorClasses[color],
                className,
            )}
            {...props}
        />
    );
};

H2.displayName = 'H2';

export default H2;
